import { useBreakpointValue } from '@chakra-ui/react';
import React from 'react';
import { createRecoilKey } from '../helpers/createKey';
import { atom, useRecoilCallback, useRecoilValue } from 'recoil';
import PaymentsFiltersForm from '../forms/PaymentsFilters/PaymentsFiltersForm';
import { PaylerModal } from '@payler/ui-components';

const paymentsFiltersModalOpenedAtom = atom({
  key: createRecoilKey('paymentsFiltersModalOpenedAtom'),
  default: false,
});

export const useShowPaymentsFiltersModal = () =>
  useRecoilCallback(
    ({ set }) =>
      () => {
        set(paymentsFiltersModalOpenedAtom, true);
      },
    [],
  );

export const useClosePaymentsFiltersModal = () =>
  useRecoilCallback(
    ({ set }) =>
      () => {
        set(paymentsFiltersModalOpenedAtom, false);
      },
    [],
  );

export const PaymentsFiltersModal = () => {
  const visible = useBreakpointValue({ base: true, lg: false });
  const open = useRecoilValue(paymentsFiltersModalOpenedAtom);
  const close = useClosePaymentsFiltersModal();
  if (!visible) return null;
  return (
    <PaylerModal close={close} open={open}>
      <PaymentsFiltersForm />
    </PaylerModal>
  );
};
